import { bridge } from 'util/appBridge'
import browser from 'util/browser'
import xhr from '@/util/xhr'
import axios from 'axios'
/* eslint no-unused-vars: ["error", { "varsIgnorePattern": "gt" }] */
import gt from '@/lib/gt'
import eventcenter from '@/util/eventcenter'

const User = {
  async sendSMSVCode(pn) {
    return new Promise(async (resolve) => {
      let firstRes = null
      try {
        firstRes = await axios.post(`/rest/api/pub/union-account/account/verifycode/ai/send/sms?username=${pn}&type=1&appId=40001&function=login&channelId=555`)
        resolve(firstRes.data)
      } catch (error) {
        if (error.response.status === 410) {
          const headers = error.response.headers
          window.initGeetest({
            gt: headers['vk-gt'],
            challenge: headers['vk-gt-challenge'],
            offline: !headers['vk-gt-initsuccess'], // false
            new_captcha: !headers['vk-gt-newcaptcha'], // false
            product: 'bind',
            width: '700px'
          }, (captchaObj) => {
            captchaObj.onReady(() => {
              captchaObj.verify()
            }).onSuccess(() => {
              const result = captchaObj.getValidate()
              error.response.config.headers['vk-gt-challenge'] = result.geetest_challenge
              error.response.config.headers['vk-gt-validate'] = result.geetest_validate
              error.response.config.headers['vk-gt-seccode'] = result.geetest_seccode
              error.response.config.headers['vk-gt-type'] = 2
              axios.request(error.response.config)
                .then(res => {
                  resolve(res.data)
                })
                .catch(err => {
                  resolve(err && err.response ? err.response.data : {})
                })
            })
              .onError(() => {
                window.location.reload()
              })
              .onClose(() => {
                resolve()
              })
          })
        } else {
          // 其他异常情况
          resolve(firstRes.data)
        }
      }
    })
  },
  tempLogin(params = {}) {
    return new Promise((resolve, reject) => {
      xhr.post('/rest/nezha-api/api/v1/account/login', {
        ...params
      }, {
        ignoreService: true
      }).then((res) => {
        if (res.code === 200) {
          localStorage.setItem('unionId', res.data.unionId)
          localStorage.setItem('studentId', res.data.studentId)
          localStorage.setItem('token', res.data.token)
          localStorage.setItem('mobile', params.mobile)
          resolve(res.data)
          eventcenter.emit('weblogin')
        } else {
          reject(res)
        }
      }).catch((e) => {
        reject(e)
      })
    })
  },
  isLogin() {
    return new Promise((resolve) => {
      if (browser.vkhybrid) {
        bridge.appExcute({
          namespace: 'nz_apply/acceptaccount'
        }).then((account) => {
          if (account.data.token && account.data.token.length > 0) {
            resolve(true)
          } else {
            resolve(false)
          }
        }).catch(() => {
          resolve(false)
        })
      } else {
        xhr.get('/rest/nezha-api/api/v1/account/me').then(() => {
          resolve(true)
        }).catch(() => {
          resolve(false)
        })
      }
    })
  },
  triggerLogin() {
    return new Promise((resolve) => {
      bridge.appExcute({
        namespace: 'nz_apply/login'
      })
        .then((result) => {
          resolve(result.data.isSuccess === true || result.data.isSuccess === 1)
        })
    })
  },
  getInfo() {
    return new Promise((resolve) => {
      if (browser.vkhybrid) {
        bridge.appExcute({
          namespace: 'nz_apply/acceptaccount'
        }).then((account) => {
          const user = account.data
          for (const i in user) {
            localStorage.setItem(i, user[i])
          }
          resolve(user)
        }).catch(() => {
          resolve({
            unionId: '',
            devicesId: '',
            studentId: '',
            token: '',
            mobile: ''
          })
        })
      } else {
        resolve({
          unionId: localStorage.getItem('unionId'),
          devicesId: localStorage.getItem('devicesId'),
          studentId: localStorage.getItem('studentId'),
          token: localStorage.getItem('token'),
          mobile: localStorage.getItem('mobile')
        })
      }
    })
  }
}

export default User
